
import React from 'react';
import '../App.css';

export default function Consulta() {

  const Logo = "images/icon/am02.png";

  return (
    <>

      <div className='consulta' >
          <img src={ Logo } alt="AgroMax" />
      </div>
      
    </>
  );
}